/* eslint-disable react/destructuring-assignment */
import { Form } from "react-bootstrap";
import PropTypes from "prop-types";

const ACFSelect = (props) => (
	// eslint-disable-next-line react/jsx-props-no-spreading
	<Form.Select {...props}>
		<option />
		{Object.entries(props.choices).map(([val, choice]) => val && <option key={val} value={val}>{choice}</option>)}
	</Form.Select>
);

ACFSelect.propTypes = {
	choices: PropTypes.shape({}).isRequired,
	onChange: PropTypes.func.isRequired
};

export default ACFSelect;
